<template>
  <div>
    <div class="p-lg-3">
      <div class="row" justify-content-between>
        <v-btn color="#1daf80" dark class="my-2" @click="novaClasse()">
          Nova Classe
        </v-btn>
      </div>
    </div>
    <div class="p-lg-1">
      <v-data-table
        :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
        :headers="header"
        :items="classes"
        class="elevation-1"
        :loading="loading"
        :loading-text="'Carregando...'"
      >
        <template v-slot:item.status="{ item }">
          <div v-if="item.status == 1" style="color: green">Ativo</div>
          <div v-else style="color: red">Inativo</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        </template>
        <template v-slot:no-data>
          <p class="text-center">Nenhum registro encontrado</p>
        </template>
      </v-data-table>
      <!-- Cadastro -->
      <v-dialog
        persistent
        max-width="500px"
        v-if="dialogCadastroClasse"
        v-model="dialogCadastroClasse"
      >
        <modal-cadastro-classe
          v-if="dialogCadastroClasse"
          @close="dialogCadastroClasse = false"
          @response="(dialogCadastroClasse = false), getClasseList()"
        />
      </v-dialog>
      <!-- Edição -->
      <v-dialog
        persistent
        max-width="500px"
        v-if="dialogEditClasse"
        v-model="dialogEditClasse"
      >
        <modal-edit-classe
          v-if="dialogEditClasse"
          :classe="classeEdit"
          @close="dialogEditClasse = false"
          @response="(dialogEditClasse = false), getClasseList()"
        />
      </v-dialog>
      <!-- Delete -->
      <!-- <v-dialog
        persistent
        max-width="500px"
        v-if="dialogDeleteClasse"
        v-model="dialogDeleteClasse"
      >
        <modal-delete-classe
          v-if="dialogDeleteClasse"
          :classe="classeEdit"
          @close="dialogDeleteClasse = false"
          @response="getClasseList($event)"
        />
      </v-dialog> -->
    </div>
  </div>
</template>

<script>
import ClassificacaoService from "@/services/classificacao_service.js";
import ModalCadastroClasse from "@/components/classificacao/classe/cadastro.vue";
import ModalEditClasse from "@/components/classificacao/classe/editar.vue";

export default {
  mixins: [],
  components: {
    ModalEditClasse,
    ModalCadastroClasse,
  },
  data: () => ({
    services: {
      classificacaoService: ClassificacaoService.build(),
    },
    header: [
      {
        text: "Descrição",
        align: "start",
        sortable: false,
        value: "descricao",
      },
      {
        text: "Status",
        align: "center",
        class: "classe-style-status",
        sortable: false,
        value: "status",
      },
      {
        text: "Ações",
        align: "center",
        class: "classe-style-status",
        value: "actions",
        sortable: false,
      },
    ],
    loading: false,
    classes: [],
    classeEdit: {},
    dialogCadastroClasse: false,
    dialogEditClasse: false,
    dialogDeleteClasse: false,
  }),
  watch: {},
  mounted() {
    this.getClasseList();
  },
  computed: {},
  methods: {
    getClasseList() {
      this.loading = true;
      this.classes = [];
      this.services.classificacaoService
        .getClasseList()
        .then(async (response) => {
          if (response.status == 200) {
            const body = await response.json();
            this.classes = body.data[0];
          } else {
            console.error(response);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    novaClasse() {
      this.dialogCadastroClasse = true;
    },
    editItem(item) {
      this.classeEdit = item;
      this.dialogEditClasse = true;
    },
  },
};
</script>
<style>
.classe-style-status {
  width: 100px !important;
}
</style>
